'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './webaccess-show.routes';

export class WebaccessShowComponent {
  constructor($stateParams, CommunityService, WebAccessService, $uibModal, $window, RecentVisits, SettingsService,
              PinnedItems, $state, ContactService) {
    'ngInject';

    this.back = _ => $window.history.back();

    this.webaccessId = $stateParams.id;
    this.$uibModal = $uibModal;
    this.$state = $state;

    this.WebAccessService = WebAccessService;
    this.ContactService = ContactService;

    this.RecentVisits = RecentVisits;
    this.PinnedItems = PinnedItems;

    this.tasks = [];
    this.activities = [];

    CommunityService.query(data => {
      this.communities = data;
      this.communityMap = {};
      data.forEach(cmty => this.communityMap[cmty.code] = cmty.name);

      SettingsService.getByName({name: 'config.app'}, appSettings => {
        this.webAccessGroupConfig = appSettings.data.webAccessGroupConfig || [];

        this.refreshData();
      });
    });

    this.RecentVisits = RecentVisits;
    this.PinnedItems = PinnedItems;
  }

  sendInvitation() {
    this.WebAccessService.sendInvitations({ids: [this.wa._id]}, _ => {
      this.refreshData();
    }, err => console.log(err));
  }

  block() {
    this.WebAccessService.update({id: this.webaccessId},{
      isBlocked: true
    }, _ => {
      this.refreshData();
    }, err => {
      console.log("Could not set to blocked");
    });
  }

  unblock() {
    this.WebAccessService.update({id: this.webaccessId},{
      isBlocked: false
    }, _ => {
      this.refreshData();
    }, err => {
      console.log("Could not set to unblocked");
    });
  }

  resetPassword() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'webaccessResetPassword',
      resolve: {
        config: function() {
          return {}
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (password) {

        that.WebAccessService.resetPassword({id: that.webaccessId}, {password}, _=> {
          console.log('success');
        }, err => console.log(err));

      },
      function () { /* cancel */ }
    );

  }

  getAccessForLabel(wa) {
    if (!wa)
      return "";

    let assns = this.getAssociations(wa);

    if (assns && wa.eVotingCode) {
      return assns + " and E-Voting (" + wa.eVotingCode + ")"
    } else if (assns) {
      return assns;
    } else if (wa.eVotingCode) {
      return "E-Voting (" + wa.eVotingCode + ")";
    }

    return "";
  }

  getAssociations(wa) {
    if (!wa)
      return "";

    let groupConfig = this.webAccessGroupConfig.find(cfg => cfg.code == wa.associationOrGroupCode);
    let IS_GROUP = !!groupConfig;

    if (IS_GROUP) {
      if (wa.associations && wa.associations.length) {
        return wa.associations.map(code => this.communityMap[code]).join(', ');
      }
    } else {
     return  this.communityMap[wa.associationOrGroupCode];
    }
  }

  /**
   *
   *
   *
   *
   */

  computedRoles(wa) {
    if (!wa)
      return [];

    let _roles = [];
    let groupConfig = this.webAccessGroupConfig.find(cfg => cfg.code == wa.associationOrGroupCode);
    let IS_GROUP = !!groupConfig;

    if (IS_GROUP) {
      _roles = _roles.concat(groupConfig.roles);

      wa.associations.forEach(code => {
        let cmty = this.communities.find(cmty => cmty.code == code);
        if (cmty && cmty.webAccess.enabled) {

          //TODO: check for role in each association for sleected contact (hier fixed owner)
          if (wa.contact)
            _roles = _roles.concat(cmty.webAccess.ownerAddRoles);

          //TODO: custom / renter roles : cmty.webAccess.renterAddRoles
        }
      })
    } else {
      _roles = _roles.concat();

      let cmty = this.communities.find(cmty => cmty.code == wa.associationOrGroupCode);
      if (cmty && cmty.webAccess.enabled) {
        _roles = _roles.concat(cmty.webAccess.defaultRoles);

        //TODO: check for role in each association for sleected contact (hier fixed owner)
        if (wa.contact)
          _roles = _roles.concat(cmty.webAccess.ownerAddRoles);

        //TODO: custom / renter roles : cmty.webAccess.renterAddRoles
      }
    }

    if (wa.additionalRoles)
      _roles = _roles.concat(wa.additionalRoles);

    return [...new Set(_roles)];
  }

  refreshData() {
    if (this.webaccessId) {
      this.WebAccessService.get({id: this.webaccessId}, data => {
        this.wa = data;

        if (this.wa.contact) {
          this.ContactService.get({id: this.wa.contact}, contact => {
            this.wa.contact = contact;
          })
        }

        this.RecentVisits.addPortfolio(this.webaccessId, "webaccess", `${this.wa.email}`);
        this.isPinned = this.PinnedItems.isPinnedPortfolio(this.webaccessId);

      }, err => {
        console.log('Could not load violation ticket from server');
      });
    }
  }

  getComposedName(contact) {
    let composedName = "";

    if (contact.lastName && contact.firstName) {
      composedName = contact.lastName + ", " + contact.firstName;
      if (contact.middleName)
        composedName += " " + contact.middleName;
    }

    if (contact.company) {
      if (composedName == "")
        composedName += contact.company;
      else
        composedName += "<br/>" + contact.company;
    }

    return composedName || "-";
  }

  openAssetUploadModal() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetUpload',
      resolve: {
        config: function() {
          return {}
        }
      }
    });

    modalInstance.result.then(resultIds => {
        that.WebAccessService.addAttachments({id: that.communityId}, resultIds, _ => {
          that.refreshData();
        }, err => {
          console.log('could not add attachments to ticket');
        });
      },
      function () { /* cancel */ }
    );

  }

}

export default angular.module('conduu.webaccessShow', [uiRouter])
  .config(routes)
  .component('webaccessShow', {
    template: require('./webaccess-show.html'),
    controller: WebaccessShowComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/webaccess/show/webaccess-show.component.js